import { usePlanningStore } from '@/stores/planning';
import { getWeekDates, formatWeekLabel } from '@/utils/planning';
import { getBoardWeeks } from '@/utils/planningWeeks';

export function WeekNav() {
  const weekOffset = usePlanningStore((s) => s.weekOffset);
  const nextWeek = usePlanningStore((s) => s.nextWeek);
  const prevWeek = usePlanningStore((s) => s.prevWeek);
  const goToCurrentWeek = usePlanningStore((s) => s.goToCurrentWeek);
  const multiWeek = usePlanningStore((s) => s.multiWeek);

  const { days, weekNumber } = getWeekDates(weekOffset);
  let weekLabel = formatWeekLabel(weekNumber, days);
  if (multiWeek) {
    const weeks = getBoardWeeks(weekOffset, true);
    weekLabel = `Week ${weeks[0].weekNumber} – ${weeks[weeks.length - 1].weekNumber}`;
  }

  return (
    <div className="flex items-center gap-3 shrink-0 justify-center">
      <button
        type="button"
        onClick={goToCurrentWeek}
        disabled={weekOffset === 0}
        className="px-2.5 py-1 text-xs font-semibold border border-gray-300 rounded-lg hover:bg-gray-50 transition-colors disabled:opacity-40 disabled:cursor-not-allowed"
      >
        Vandaag
      </button>
      <button
        type="button"
        onClick={prevWeek}
        className="p-1.5 rounded-lg hover:bg-gray-100 transition-colors"
        aria-label="Vorige week"
      >
        <svg
          className="w-4 h-4 text-td-navy"
          fill="none"
          stroke="currentColor"
          viewBox="0 0 24 24"
          aria-hidden="true"
        >
          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M15 19l-7-7 7-7" />
        </svg>
      </button>
      <span className="text-sm lg:text-base font-bold text-td-navy whitespace-nowrap">
        {weekLabel}
      </span>
      <button
        type="button"
        onClick={nextWeek}
        className="p-1.5 rounded-lg hover:bg-gray-100 transition-colors"
        aria-label="Volgende week"
      >
        <svg
          className="w-4 h-4 text-td-navy"
          fill="none"
          stroke="currentColor"
          viewBox="0 0 24 24"
          aria-hidden="true"
        >
          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 5l7 7-7 7" />
        </svg>
      </button>
    </div>
  );
}
